import React, { useEffect, useState } from "react";
// import qr from "../assets/qr.jpeg";
import { RiFileCopyLine } from "react-icons/ri";
import { SiWhatsapp } from "react-icons/si";
import useDialog from "../hooks/useDialog";
import { CopyToClipboard } from "react-copy-to-clipboard";
import config from "../config";

const rekening = [
  { nama: "Aji Susanto (BRI)", rek: "043301009467509" },
  { nama: "Aji Susanto (Mandiri)", rek: "1550011332445" },
  { nama: "Nike Indrawati (BCA)", rek: "5390581183" },
];

const ModalAmpau = () => {
  const { handleClose } = useDialog();
  // const [isCopied, setIsCopied] = useState({
  //   id0: false,
  //   id1: false,
  //   id2: false,
  // });
  // const { id0, id1, id2 } = isCopied;
  const [isCopied, setIsCopied] = useState(false);
  const [isCopied2, setIsCopied2] = useState(false);
  const [isCopied3, setIsCopied3] = useState(false);

  useEffect(() => {
    const copied = setTimeout(() => {
      if (isCopied) {
        setIsCopied(false);
      }
    }, 2000);
    return () => {
      clearTimeout(copied);
    };
  }, [isCopied]);

  useEffect(() => {
    const copied = setTimeout(() => {
      if (isCopied2) {
        setIsCopied2(false);
      }
    }, 2000);
    return () => {
      clearTimeout(copied);
    };
  }, [isCopied2]);

  useEffect(() => {
    const copied = setTimeout(() => {
      if (isCopied3) {
        setIsCopied3(false);
      }
    }, 2000);
    return () => {
      clearTimeout(copied);
    };
  }, [isCopied3]);
  // useEffect(() => {
  //   const copied = setTimeout(() => {
  //     if (id1) {
  //       setIsCopied({ ...isCopied, id1: false });
  //     }
  //   }, 3000);

  //   return () => {
  //     clearTimeout(copied);
  //   };
  // }, [id1]);
  // useEffect(() => {
  //   const copied = setTimeout(() => {
  //     if (id2) {
  //       setIsCopied({ ...isCopied, id2: false });
  //     }
  //   }, 3000);

  //   return () => {
  //     clearTimeout(copied);
  //   };
  // }, [id2]);

  return (
    <div>
      <div className="p-10 flex flex-col items-center space-y-3   bg-[url('https://galipatstory.com/wp-content/uploads/2020/12/bg.jpg')]">
        <h5 className="text-yellow-800 text-4xl font-sacramento">
          Kirim Angpau
        </h5>
        <p className="text-center text-gray-500">
          Bagi yang ingin memberikan angpau sebagai hadiah untuk pernikahan
          kami, silakan transfer ke rekening ya 😊
        </p>
        <div className="grid grid-cols-1   gap-5">
          <div className="flex flex-col items-center space-y-3 ">
            <div className="bg-yellow-50 flex flex-col items-center justify-center  p-2 rounded-xl  w-full ">
              <p>{rekening[0].nama} </p>
              <p>{rekening[0].rek} </p>
            </div>
            {/* <img
              className=" w-full   rounded-md"
              src={qr}
              alt=""
            /> */}
            <CopyToClipboard
              text={rekening[0].rek}
              onCopy={() => setIsCopied(true)}
            >
              <button
                className={`${
                  isCopied
                    ? "hover:bg-green-600 bg-green-500 "
                    : "hover:bg-gray-600 bg-gray-500 "
                }  transition-all  rounded-md sm:px-6 py-2 w-full   text-white flex justify-center items-center`}
              >
                {isCopied ? (
                  "DISALIN!"
                ) : (
                  <>
                    <RiFileCopyLine className="mr-3 " color="white" /> SALIN NO
                    REK
                  </>
                )}
              </button>
            </CopyToClipboard>
          </div>
          <div className="flex flex-col items-center space-y-3 ">
            <div className="bg-yellow-50 flex flex-col items-center justify-center  p-2 rounded-xl  w-full ">
              <p>{rekening[1].nama} </p>
              <p>{rekening[1].rek} </p>
            </div>
            {/* <img
              className=" w-full   rounded-md"
              src={qr}
              alt=""
            /> */}
            <CopyToClipboard
              text={rekening[1].rek}
              onCopy={() => setIsCopied2(true)}
            >
              <button
                className={`${
                  isCopied2
                    ? "hover:bg-green-600 bg-green-500 "
                    : "hover:bg-gray-600 bg-gray-500 "
                }  transition-all  rounded-md sm:px-6 py-2 w-full   text-white flex justify-center items-center`}
              >
                {isCopied2 ? (
                  "DISALIN!"
                ) : (
                  <>
                    <RiFileCopyLine className="mr-3 " color="white" /> SALIN NO
                    REK
                  </>
                )}
              </button>
            </CopyToClipboard>
          </div>
          <div className="flex flex-col items-center space-y-3 ">
            <div className="bg-yellow-50 flex flex-col items-center justify-center  p-2 rounded-xl  w-full ">
              <p>{rekening[2].nama} </p>
              <p>{rekening[2].rek} </p>
            </div>
            {/* <img
              className=" w-full   rounded-md"
              src={qr}
              alt=""
            /> */}
            <CopyToClipboard
              text={rekening[2].rek}
              onCopy={() => setIsCopied3(true)}
            >
              <button
                className={`${
                  isCopied3
                    ? "hover:bg-green-600 bg-green-500 "
                    : "hover:bg-gray-600 bg-gray-500 "
                }  transition-all  rounded-md sm:px-6 py-2 w-full   text-white flex justify-center items-center`}
              >
                {isCopied3 ? (
                  "DISALIN!"
                ) : (
                  <>
                    <RiFileCopyLine className="mr-3 " color="white" /> SALIN NO
                    REK
                  </>
                )}
              </button>
            </CopyToClipboard>
          </div>
        </div>

        <a
          href={config.waCowo}
          className={`hover:bg-gray-600 bg-gray-500 rounded-md px-6 py-2 w-full sm:w-1/2 text-white flex justify-center items-center`}
        >
          <SiWhatsapp className="mr-3 " color="white" /> Whatsapp
        </a>

        <p className="text-center text-gray-500">
          Untuk konfirmasi pengiriman Angpau boleh ke nomor Whatsapp mempelai.
          Terimakasih 😊🙏
        </p>
        <button
          onClick={handleClose}
          className="hover:bg-red-600 font-bold bg-red-500 rounded-md px-6 py-2 w-full sm:w-1/2 text-white flex justify-center items-center"
        >
          CLOSE
        </button>
      </div>
    </div>
  );
};

export default ModalAmpau;
